import { render, staticRenderFns } from "./FireNumberOfExternalDamages.vue?vue&type=template&id=6c5f88c5&scoped=true"
import script from "./FireNumberOfExternalDamages.vue?vue&type=script&lang=ts"
export * from "./FireNumberOfExternalDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f88c5",
  null
  
)

export default component.exports